import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { AdminHeader } from "@/components/platform/AdminHeader";

const CH = [["whatsapp", "WhatsApp"], ["facebook", "Facebook"], ["x", "X"], ["telegram", "Telegram"], ["copy", "Copy link"]];
const myDate = (d) => d.toLocaleDateString("en-CA", { timeZone: "Asia/Kuala_Lumpur" });
const KINDS = [["", "All"], ["venue", "Venues"], ["event", "Events"], ["game", "Games"]];

export function SharesAdmin() {
  const today = new Date();
  const [start, setStart] = useState(myDate(new Date(today.getFullYear(), today.getMonth(), 1)));
  const [end, setEnd] = useState(myDate(today));
  const [kind, setKind] = useState("");
  const [d, setD] = useState(null);
  useEffect(() => { setD(null); api.get("/asv/admin/shares", { params: { start, end, kind } }).then((r) => setD(r.data)).catch((e) => toast.error(formatErr(e))); }, [start, end, kind]);
  return (
    <div data-testid="shares-admin">
      <AdminHeader title="Shares" sub="How often venues, events and games were shared, and where">
        <div className="flex flex-wrap items-center gap-2">
          <Input type="date" value={start} onChange={(e) => setStart(e.target.value)} className="w-40" data-testid="shares-start" />
          <Input type="date" value={end} onChange={(e) => setEnd(e.target.value)} className="w-40" data-testid="shares-end" />
        </div>
      </AdminHeader>
      <div className="mb-4 flex flex-wrap gap-2">{KINDS.map(([k, l]) => (
        <button key={k} type="button" onClick={() => setKind(k)} data-testid={`shares-kind-${k || "all"}`}
          className={`rounded-full border px-3 py-1.5 text-xs font-semibold ${kind === k ? "border-emerald-500 text-emerald-300" : "border-slate-700 text-slate-400"}`}>{l}</button>))}</div>
      {!d ? <Loader2 className="h-6 w-6 animate-spin text-emerald-400" /> : <>
        <div className="mb-4 grid grid-cols-2 gap-3 sm:grid-cols-6">
          <div className="card-surface p-4"><p className="text-xs text-slate-500">Total shares</p><p className="text-2xl font-bold text-white" data-testid="shares-total">{d.total}</p></div>
          {CH.map(([k, l]) => <div key={k} className="card-surface p-4"><p className="text-xs text-slate-500">{l}</p><p className="text-xl font-bold text-white" data-testid={`shares-ch-${k}`}>{d.by_channel[k]}</p></div>)}
        </div>
        <div className="card-surface overflow-x-auto p-2"><table className="w-full min-w-[720px] text-sm" data-testid="shares-table">
          <thead><tr className="text-left text-xs uppercase text-slate-500"><th className="p-3">Listing</th><th className="p-3 text-right">Shares</th>{CH.map(([k, l]) => <th key={k} className="p-3 text-right">{l}</th>)}</tr></thead>
          <tbody>{d.listings.map((x) => (
            <tr key={`${x.kind}-${x.key}`} className="border-t border-slate-800" data-testid={`shares-row-${x.key}`}>
              <td className="p-3"><p className="font-semibold text-white">{x.title}</p><p className="text-xs text-slate-500"><span className="capitalize">{x.kind}</span>{x.vendor_slug ? ` · ${x.vendor_slug}` : ""}</p></td>
              <td className="p-3 text-right font-bold text-white">{x.shares}</td>{CH.map(([k]) => <td key={k} className="p-3 text-right text-slate-300">{x[k]}</td>)}
            </tr>))}</tbody></table>
          {!d.listings.length && <p className="p-6 text-center text-sm text-slate-500" data-testid="shares-empty">No shares in this period.</p>}
        </div>
      </>}
    </div>
  );
}
